import React, { useState } from "react";
import "../../components/DashboardModule/NotVerifiedModal.css";
import logostelmart from '../../assets/images/logostelmart.png';
import { RxCross2 } from "react-icons/rx";
import VerifyAccountModal from "./VerifyAccountModal";
import SidebarTab from '../SidebarTab/SidebarTab';
const PVerifyAccount = ({ onClose }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = (e) => {
        e.stopPropagation();
        console.log("Opening modal... current state:", isModalOpen);
        setIsModalOpen(true);
    };

    const closeModal = (e) => {
        e?.stopPropagation();
        console.log("Closing modal...");
        setIsModalOpen(false);
    };

    return (
        <div className="verification-container">
            <SidebarTab />
            <div className="my-business-details-review">
                <div className="main-wrapper-with-btn">

                    <h1>  Documents Submitted for Verification</h1>
                    <p className="notModal-text font-poppins text-verify">
                        Thank you for submitting your documents. Our team is currently reviewing them.
                    </p>
                    <p className="notModal-text font-poppins text-verify">
                    Please allow 24 to 48 hours for the verification process to be completed. You will receive an update as soon as the review is finished.
                    </p>
                    <p className="notModal-text font-poppins text-verify">
                    If you have any questions or need assistance, feel free to contact us at <a href="mailto:help@stelmart.co.in">help@stelmart.co.in</a> — we're here to help!
                   </p>


                {/* <button
                    className="notModal-button font-poppins"
                    onClick={openModal}
                >
                  VERIFY ACCOUNT
                </button> */}
                {isModalOpen && <VerifyAccountModal isOpen={isModalOpen} onClose={closeModal} />}
            </div>
        </div>
        </div >
    );
};

export default PVerifyAccount;